import React, { useState, useEffect, useContext } from 'react'
import { Modal, ModalBody, Col, Input, Button, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap'
import styled from 'styled-components'
import BlockUi from 'react-block-ui'
import { Loader } from 'react-loaders'
import { PaymentInputsWrapper, usePaymentInputs } from 'react-payment-inputs'
import { AuthContext } from '../../contexts/AuthContext'
import images from 'react-payment-inputs/images'
import swal from 'sweetalert'
import api from '../../services/api'
import { formatBRL } from '../../helpers/utils'
import decimal from '../../helpers/decimal'
import { toast } from 'react-toastify'

const StyledModalBody = styled(ModalBody)`
  @media (max-width: 768px) {
    padding: 35px 5px;
  }
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

function FullPaymentModal(props) {
  const { dispatch, auth } = useContext(AuthContext)
  const [loading, setLoading] = useState(false)
  const [cardNumber, setCardNumber] = useState('')
  const [holder, setHolder] = useState('')
  const [brand, setBrand] = useState('')
  const [expirationDate, setExpirationDate] = useState('')
  const [cvc, setCVC] = useState('')
  const [remainingPrice, setRemainingPrice] = useState(0)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [installments, setInstallments] = useState(0)
  const [installmentValue, setInstallmentValue] = useState(0)

  useEffect(() => {
    if(props.visible === true) {
      api.get(`/remaining-payment/${props.payment.recurrent.recurrentPaymentId}`).then(response => {
        setRemainingPrice(response.remainingPrice) 
      }).catch(error => {
        console.log(error)
      })
    }
  }, [props.visible])

  const toggle = () => setDropdownOpen(prevState => !prevState);

  const handleSubmit = event => {
    event.preventDefault()

    if(cardNumber === '') return swal('Preencha todos os dados')
    if(holder === '') return swal('Preencha todos os dados')
    if(expirationDate === '') return swal('Preencha todos os dados')
    if(!cvc === '') return swal('Preencha todos os dados')

    swal({
      title: "Confirmar pagamento",
      text: `Você confirma o pagamento de ${formatBRL(remainingPrice)} em ${installments} ${installments > 1 ? 'vezes' : 'vez'} de ${formatBRL(installmentValue)}?`,
      icon: "warning",
      buttons: {
        cancel: "Voltar",
        confirm: "Sim"
      },
      dangerMode: true,
    })
      .then((willPay) => {
        if (willPay) {
          const data = { 
            oldPayment: props.payment,
            payment: {
              amount: remainingPrice,
              installments: parseInt(installments)
            }, 
            creditCard: {
              cardNumber: cardNumber.replace(/\s/g, ''),
              holder,
              expirationDate: expirationDate.replace(/\s/g, '').replace("/", "/20"),
              securityCode: cvc,
              brand: meta.cardType.type === "mastercard" ? "Master" : meta.cardType.type
            },
            user: auth.user,
            course: props.payment.course
          }

          api.post("/remaining-payment", data).then(response => {
            toast.success(response.message)
            props.handleModal()
            setCardNumber('')
            setHolder('')
            setExpirationDate('')
            setCVC('')
            setBrand('')
            setInstallmentValue(0)
          }).catch(error => {
            console.log(error)
          })
        } else {
          return false;
        }
      });
  }

  // const formatExpirationDate = expirationDate => {
  //   let withOutSpaces = expirationDate.replace(/\s/g, '')
  //   const left = withOutSpaces.substr(0, 2)
  //   const right = withOutSpaces.substr(3, 4)
  //   const formatted = `${left}/20${right}`

  //   return formatted
  // }

  const handleInstallmentSelection = (event, remainingPrice) => {
    event.preventDefault()

    const installmentNumber = parseInt(event.target.value)

    setInstallments(installmentNumber)
    setInstallmentValue(decimal.div(remainingPrice, installmentNumber))
  }

  const ERROR_MESSAGES = {
    emptyCardNumber: 'O número do cartão não pode estar vazio.',
    invalidCardNumber: 'O número do cartão é inválido.',
    emptyExpiryDate: 'A data de expiração não pode estar vazia.',
    monthOutOfRange: 'O mês de expiração deve estar entre 01 e 12.',
    yearOutOfRange: 'O ano de expiração não pode estar no passado.',
    dateOutOfRange: 'A data de expiração não pode estar no passado.',
    invalidExpiryDate: 'A data de expiração é inválida.',
    emptyCVC: 'O código de segurança não pode estar vazio.',
    invalidCVC: 'O código de segurança é inválido.'
  }

  const {
    meta,
    wrapperProps,
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps
  } = usePaymentInputs({ errorMessages: ERROR_MESSAGES });

  return (
    <>
      <Modal isOpen={props.visible} toggle={props.handleModal} size="lg" centered>
        <StyledModalBody>
          <BlockUi tag="div" blocking={loading} loader={<Loader active type="line-scale-party" color="#296ba9" />} >
            <FormContainer>
              <Col xs={12} md={7} style={{ textAlign: "center" }}>
                  <h3 style={{ marginBottom: "1em" }}>Efetuar pagamento restante</h3>

                  <PaymentInputsWrapper {...wrapperProps} style={{ width: '100%', marginBottom: '1em' }}>
                    <svg {...getCardImageProps({ images })} />
                    <input {...getCardNumberProps({ onChange: (event) => setCardNumber(event.target.value) })} placeholder="Nº do Cartão de Crédito" value={cardNumber} />
                    <input {...getExpiryDateProps({ onChange: (event) => setExpirationDate(event.target.value) })} placeholder="MM/AA" value={expirationDate} />
                    <input {...getCVCProps({ onChange: (event) => setCVC(event.target.value) })} value={cvc} />
                  </PaymentInputsWrapper>

                  <Input
                    placeholder="Titular"
                    value={holder}
                    onChange={event => setHolder(event.target.value)}
                    style={{ marginBottom: "1em" }}
                  />

                  <Dropdown
                    isOpen={dropdownOpen}
                    toggle={toggle}
                    style={{ marginBottom: '1em'}}
                    placeholder="Selecione o número de parcelas"
                  >
                    <DropdownToggle caret style={{ width: '100%' }}>
                      {installments ? installments + " X " + formatBRL(installmentValue) : "Selecione o número de parcelas" }
                    </DropdownToggle>

                    <DropdownMenu
                      style={{ textAlign: 'center', width: '100%'}}
                      onClick={event => handleInstallmentSelection(event, remainingPrice)}
                    >
                      <DropdownItem value="1">1 X {formatBRL(remainingPrice)}</DropdownItem>
                      <DropdownItem value="2">2 X {formatBRL(decimal.div(remainingPrice, 2))}</DropdownItem>
                      <DropdownItem value="3">3 X {formatBRL(decimal.div(remainingPrice, 3))}</DropdownItem>
                      <DropdownItem value="4">4 X {formatBRL(decimal.div(remainingPrice, 4))}</DropdownItem>
                      <DropdownItem value="5">5 X {formatBRL(decimal.div(remainingPrice, 5))}</DropdownItem>
                      <DropdownItem value="6">6 X {formatBRL(decimal.div(remainingPrice, 6))}</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>

                  <Button onClick={() => props.handleModal()}>
                    Voltar
                  </Button>

                  <Button
                    style={{ backgroundColor: "rgba(41,107,169,1)", border: 'none', margin: "1em" }}
                    onClick={(event) => handleSubmit(event)}
                  >
                    Efetuar pagamento
                  </Button>
              </Col>
            </FormContainer>
          </BlockUi>
        </StyledModalBody>
      </Modal>
    </>
  );
}



export default FullPaymentModal;